import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [{ key: "userLogin", name: "global:loginattempts.userLogin" },{ key: "loggedUser.uuid", name: "global:loginattempts.loggedUserUuid" }],
    selectedSearchFields: ["userLogin","loggedUser.uuid"],
  },
};

const loginAttemptsReducer = createSlice({
  name: "loginAttemptsReducer",
  initialState,
  reducers: {
    updateReducer: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearReducer: () => initialState,
  },
  extraReducers: {},
});

export const { updateReducer, clearReducer } = loginAttemptsReducer.actions;

export default loginAttemptsReducer.reducer;
